"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidOrderIdException = void 0;
const ts_error_1 = __importDefault(require("ts-error"));
class InvalidOrderIdException extends ts_error_1.default {
    constructor(orderId) {
        super(`Cannot map tenant from invalid order ID: ${orderId}`);
        this.orderId = orderId;
    }
}
exports.InvalidOrderIdException = InvalidOrderIdException;
//# sourceMappingURL=invalid-order-id.exception.js.map